import PropTypes from "prop-types";
import socialLinkType from "./socialLinkType";

export default PropTypes.shape({
  about: PropTypes.string,
  customTerms: PropTypes.string,
  avgResponseTime: PropTypes.string,
  city: PropTypes.string,
  postalAddress: PropTypes.string,
  companyName: PropTypes.string,
  employeesCount: PropTypes.number,
  logo: PropTypes.string,
  website: PropTypes.string,
  glassDoorLink: PropTypes.string,
  socialLinks: PropTypes.arrayOf(socialLinkType),
  email_domains: PropTypes.arrayOf(PropTypes.string),
});
